<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <i class="icon-note"></i> Movimientos - Auxiliar por Cuenta
          </div>
          <b-row>
            <b-col cols="11" col md="2">
              <label for="desde">Inicio:&nbsp; </label><br />
              <date-picker
                id="desde"
                :lang="lang"
                v-model="desde"
                format="YYYY-MM-DD"
                type="date"
                style="width: 100%"
                :disabled="cargandoDatos"
              >
              </date-picker>
            </b-col>
            <b-col cols="11" col md="2">
              <label for="hasta">Fin:&nbsp; </label><br />
              <date-picker
                id="hasta"
                :lang="lang"
                v-model="hasta"
                format="YYYY-MM-DD"
                type="date"
                style="width: 100%"
                :disabled="cargandoDatos"
              >
              </date-picker>
            </b-col>

            <b-col cols="11" col md="3">
              <label for="cta_desde">Cuenta:</label>
              <multiselect
                v-model="cuenta_desde"
                placeholder="Buscar cuenta..."
                :options="cuentas"
                :custom-label="labelSelectMuc"
                selectLabel="Presione enter para seleccinar"
                deselectLabel="Presione enter para remover"
                selectedLabel="Seleccionado"
                track-by="id"
                :searchable="true"
                :loading="false"
                :internal-search="false"
                :options-limit="15"
                :limit="10"
                :allow-empty="true"
                open-direction="bottom"
                @search-change="getCuentas($event)"
                id="cta_desde"
              >
                <template slot="noResult"> No hay resultados</template>
                <template slot="noOptions">
                  Buscar por número o nombre de cuenta</template
                >
              </multiselect>
            </b-col>

            <b-col cols="11" col md="2">
              <label for="moneda">Moneda:</label>
              <b-form-radio-group
                id="moneda"
                v-model="moneda_id"
                :options="MoneyOptions"
                class="mb-3"
                value-field="id"
                text-field="text"
                @change="cambiaCuentaMoneda"
              ></b-form-radio-group>
              <!-- <b-form-group label="Centro">
                <b-input-group>
                  <b-form-select
                    v-model="filtros.centro_id"
                    :options="centros"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="min-width: 80px"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group> -->
            </b-col>
            <b-col cols="6" col md="2" ml-md="1">
              <button
                class="btn btn-sm btn-success text-white"
                @click="cargarDatos('n')"
                style="margin-top: 2.4em; margin-right: 0.5em"
                :disabled="cargandoDatos"
                title="Cargar datos"
              >
                <i class="fa fa-search"></i>
              </button>

              <button
                class="btn btn-sm btn-success text-white"
                @click="cargarDatos('s')"
                style="margin-top: 2.4em"
                :disabled="cargandoDatos"
                title="Exportar a Excel"
              >
                <i class="fa fa-file-excel-o"></i>
              </button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-show="!registros.length">
      <b-col cols="12">
        <b-card>
          <p class="text-center" style="margin: 0">
            {{
              yaSeRealizoPrimeraBusqueda
                ? "No hay datos disponibles."
                : "Seleccione un rango de fecha"
            }}
          </p>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-show="registros.length">
      <b-col cols="12" class="table-responsive">
        <b-card>
          <b-table
            hover
            small
            show-empty
            empty-text="No hay registros para mostrar"
            responsive="sm"
            :items="registros"
            :fields="fields"
            :per-page="filtros.pagesize"
            :busy="isLoading"
          >
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>&nbsp; &nbsp;Cargando...</strong>
              </div>
            </template>

            <template v-slot:cell(cd_codigo)="row">
              <b-link
                target="_blank"
                :to="{
                  name: 'pdf-comprobante',
                  params: { id: row.item.cd_id, name: row.item.cd_codigo },
                }"
                >{{ row.item.cd_codigo }}
              </b-link>
            </template>

            <template v-slot:cell(fecha)="row">
              {{ formatoFecha(row.item.fecha) }}
            </template>
            <template v-slot:cell(concepto)="row">
              {{ row.item.concepto | truncate(65) }}
            </template>

            <template v-slot:cell(inicial)="row">
              {{ row.item.inicial | currency("", 2, { thousandsSeparator: "," }) }}
            </template>
            <template v-slot:cell(debito)="row">
              {{ row.item.debito | currency("", 2, { thousandsSeparator: "," }) }}
            </template>
            <template v-slot:cell(credito)="row">
              {{ row.item.credito | currency("", 2, { thousandsSeparator: "," }) }}
            </template>
            <template v-slot:cell(saldo)="row">
              {{ row.item.saldo | currency("", 2, { thousandsSeparator: "," }) }}
            </template>
          </b-table>
          <b-pagination
            v-model="filtros.currentPage"
            :total-rows="totalRows"
            :per-page="filtros.pagesize"
            class="mt-4"
            @input="cargarDatos()"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Vue2Filters from "vue2-filters";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import { cambiarFormatoFecha } from "../../shared/utils";

export default {
  mixins: [Vue2Filters.mixin],
  name: "LDiario-form",
  components: { DatePicker, Multiselect },
  mounted() {
    //this.cargarCentros();
  },
  data: () => {
    return {
      moneda_id: 1,
      MoneyOptions: [
        { text: "C$", id: 1 },
        { text: "USD", id: 2 },
      ],
      isLoading: true,
      cuenta_desde: "",
      cuentas: [],
      filtros: {
        empresa_id: 1,
        pagesize: 100,
        currentPage: 1,
        centro_id: 0,
        area: undefined,
        desde: undefined,
        hasta: undefined,
        excel: "n",
        cuenta_desde: undefined,
      },
      lang: { formatLocale: { firstDayOfWeek: 1 } },
      desde: undefined,
      hasta: undefined,
      cargandoDatos: false,
      registros: [],
      totalRows: 0,
      centros: [],
      yaSeRealizoPrimeraBusqueda: false,
      fields: [
        { key: "fecha", class: "text-center" },
        {
          key: "cuenta",
          class: "text-center",
        },
        {
          key: "concepto",
        },
        {
          label: "Código",
          key: "cd_codigo",
          class: "text-center",
        },
        {
          key: "inicial",
          class: "text-right",
          label: "inicial",
        },
        {
          key: "debito",
          class: "text-right",
          label: "Debe",
        },
        {
          key: "credito",
          class: "text-right",
          label: "Haber",
        },
        {
          key: "saldo",
          class: "text-right",
          label: "Saldo",
        },
      ],
    };
  },
  methods: {
    async getCuentas(cuenta) {
      this.yaSeRealizoPrimeraBusqueda = false;
      this.registros = [];
      // eslint-disable-next-line no-undef
      const res = await axios.post("/api/catalogos/busquedacta", {
        empresa_id: this.empresaId,
        cuenta,
        tipo: "Operativa",
      });
      const suggestions = res.data.data;
      this.cuentas = suggestions;
      this.yaSeRealizoPrimeraBusqueda = false;
    },
    labelSelectMuc({ cuenta, nombre }) {
      return cuenta + " " + this.text_truncate(nombre, 35);
    },
    text_truncate(str, length, ending) {
      if (ending == null) {
        ending = "...";
      }
      if (typeof str != "undefined") {
        if (str.length > length) {
          return str.substring(0, length - ending.length) + ending;
        } else {
          return str;
        }
      }
    },
    formatoFecha(date) {
      // eslint-disable-next-line no-undef
      return moment(date).format("DD/MM/YYYY");
    },
    async cargarCentros() {
      try {
        // eslint-disable-next-line no-undef
        const { data } = await axios.get("/api/catalogos/centros");
        this.centros = data.data;
        this.centros.unshift({ id: 0, nombre: "Todos" });
      } catch (error) {
        console.log(error);
      }
    },
    cambiaCuentaMoneda(){
      this.registros = [];
      this.yaSeRealizoPrimeraBusqueda = false;
      if(this.filtros.cuenta_desde) return toastr["info"]("Ha cambiado la moneda, favor presionar nuevamente en el botón 🔍 para buscar registros con la moneda seleccionada");
    },
    async cargarDatos(excel = "n") {
      if (!this.desde)
        return toastr["warning"]("Favor ingresar una fecha valida en Desde");
      if (!this.hasta)
        return toastr["warning"]("Favor ingresar una fecha valida en Hasta");
      if(!this.yaSeRealizoPrimeraBusqueda) this.filtros.currentPage = 1;
      this.yaSeRealizoPrimeraBusqueda = true;
      this.filtros.desde = cambiarFormatoFecha(this.desde);
      this.filtros.hasta = cambiarFormatoFecha(this.hasta);

      this.filtros.cuenta_desde =
        this.cuenta_desde && this.cuenta_desde.cuenta
          ? this.cuenta_desde.cuenta
          : undefined;
      this.filtros.empresa_id = this.empresaId;
      this.filtros.excel = excel;
      this.filtros.moneda_id = this.moneda_id;
      this.cargandoDatos = true;

      try {
        if (excel == "s") {
          toastr["info"]("Generando Excel. Favor Espere");
          try {
            // eslint-disable-next-line no-undef
            const response = await axios.post("/api/reportes/auxdiario", this.filtros, {
              responseType: "arraybuffer",
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `AuxiliarDiario-${this.filtros.desde} al ${this.filtros.hasta}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
          } catch (error) {
            console.log("aca anda");
            console.log(error);
          }
        } else {
          // eslint-disable-next-line no-undef
          let { data } = await axios.post("/api/reportes/auxdiario", this.filtros);
          this.registros = [];
          this.totalRows = data.total ? data.total : 0;
          let datos = data.data;
          datos.forEach((d) => {
            this.registros.push({
              cuenta: d.cuenta,
              fecha: cambiarFormatoFecha(d.fecha),
              cd_codigo: d.cd_codigo,
              cd_id: d.cd_id,
              concepto: d.concepto,
              inicial: d.inicial,
              debito: d.debito,
              credito: d.credito,
              saldo: d.saldo,
            });
          });
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error);
      }
      this.cargandoDatos = false;
    },
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"]),
  },
};
</script>
<style scoped>
.tdpl6 {
  padding-left: 30px !important;
}
.negrita {
  font-weight: bold;
}
.debe_haber {
  width: 200px;
}
.cuentas {
  width: 150px;
}
.table {
  margin: 0;
}
.table thead th {
  border: solid #c8ced3;
  border-width: 0 0 2px 0;
}
.fs1 {
  font-size: 1.2em;
}
.fs2 {
  font-size: 1.1em;
}
.fs3 {
  font-size: 1em;
}
.fs4 {
  font-size: 0.9em;
}
.table td {
  padding: 0;
  border: none;
}
* {
  line-height: 1 !important;
}
</style>
